'use strict';

angular.module('licensure.services')
    .factory('LicenseRequestLevels', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicenseRequestLevels', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;